module.exports = __webpack_public_path__ + "static/media/icon_schedule_message.e0e22922.svg";